import { Box } from "@mui/material";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import type { B2B_Invoice_list } from "../type/b2bType";
import B2BInvoiceTable from "./B2BInvoiceTable";
import CreateB2BInvoiceForm from "./CreateB2BInvoiceForm";

const B2BInvoice = () => {
	const [openCreateModal, setOpenCreateModal] = useState(false);
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [dateRange, setDateRange] = useState<{
		start_date: string;
		end_date: string;
	}>({
		start_date: "",
		end_date: "",
	});
	const [searchParams, setSearchParams] = useState({ name: "", status: "" });
	const { data, isLoading } = useGetQueryWithTotal<B2B_Invoice_list[]>({
		endPoint: "/api/admin/b2b/invoice",
		queryKeys: ["b2b_invoice"],
		params: {
			...pagination,
			search: searchParams.name || undefined,
			status: searchParams.status || undefined,
			start_date: dateRange.start_date || undefined,
			end_date: dateRange.end_date || undefined,
		},
	});

	return (
		<>
			<CommCard
				showCardHeader
				showSearch
				showDateRange
				showStatus
				showButton
				btnText="Create Invoice"
				handleBtnForModalFun={() => setOpenCreateModal(true)}
				headerTitle={`Buyer/Seller Invoice List (${data?.total || 0})`}
				handleSearchFun={(name) => {
					setSearchParams((prev) => ({ ...prev, name }));
					setPagination((prev) => ({ ...prev, skip: 0 }));
				}}
				statusOptions={[
					{ id: "Paid", name: "Paid" },
					{ id: "Unpaid", name: "Unpaid" },
					{ id: "Partial Paid", name: "Partial Paid" },
				]}
				handleSelectStatus={(status) => {
					setSearchParams((prev) => ({ ...prev, status }));
					setPagination((prev) => ({ ...prev, skip: 0 }));
				}}
				handleDateRange={(date) => {
					setDateRange(date);
					setPagination((prev) => ({ ...prev, skip: 0 }));
				}}
				helmetTitle="BTTF - Buyer/Seller B2B list"
			>
				<B2BInvoiceTable
					loading={isLoading}
					invoiceList={data?.data}
					paginationSkip={pagination.skip}
				/>

				<Box p={2}>
					<CommonPagination
						total={data?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
			</CommCard>

			<ModalsWrapper
				showModal={openCreateModal}
				setShowModal={setOpenCreateModal}
				modalData={{ title: "Create B2B Invoice" }}
				maxWidth="md"
			>
				<CreateB2BInvoiceForm handleClose={() => setOpenCreateModal(false)} />
			</ModalsWrapper>
		</>
	);
};

export default B2BInvoice;
